import styled from 'styled-components';
import { Row, Col } from 'react-flexbox-grid';

import successIcon from '../../assets/icons/success.svg';
import warningIcon from '../../assets/icons/warning.svg';
import errorIcon from '../../assets/icons/error.svg';


export const ContactRow = styled(Row)`
  width: 85%;

  @media (max-width: 64em) {
    width: auto;
  }
`;

export const FormColumn = styled(Col)`
  align-items: center;
  display: flex;
`;

export const FormRow = styled(Row)`
  width: 100%;
`;

export const ContactInput = styled.input`
  width: calc(100% - 2.5vw);
  border: none;
  border-bottom: 1px solid;
  outline: none;
  padding: 0.5vw;
  padding-left: 0;
  margin-bottom: 14px;
  font-size: 1.1vw;
  background-color: transparent;
  background-repeat: no-repeat;
  background-size: 1.5vw;
  background-position-y: 0.4vw;
  background-position-x: 100%;
  background-image: ${(props) => {
    if (props.valid === 'yetToValidate') {
      return `url(${warningIcon})`;
    } else if (props.valid === 'valid') {
      return `url(${successIcon})`;
    }
    return `url(${errorIcon})`;
  }};
  border-bottom-color: ${(props) => {
    if (props.valid === 'yetToValidate') {
      return '#EFCE4A';
    } else if (props.valid === 'valid') {
      return '#25AE88';
    }
    return '#D75A4A';
  }};
  -webkit-transition: all 1s;
  transition: all 1s;

  @media (max-width: 64em) {
    padding: 2.5vw;
    font-size: 3.3vw;
    margin-bottom: 6vw;
    background-size: 4.5vw;
    background-position-y: 2.4vw;
  }
`;

export const ContactTextArea = ContactInput.withComponent('textarea');

export const ContactButtonsContainer = styled.div`
  height: 100%;
  margin-left: 14px;
  border-left: 1px solid;
  padding-left: 16px;
  display: flex;
  flex-direction: column;

  @media (max-width: 64em) {
    border: none;
    flex-direction: row;
    padding: 2vw;
    margin-left: 0;
    margin-top: -2vw;
    margin-bottom: 9vw;
  }
`;

export const ContactButtonContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;

  &.first{
    border-bottom: 1px solid;
  }

  @media (max-width: 64em) {
    &.first{
      border: none;
    }
  }
`;

export const ContactButton = styled.button`
  margin: auto;
  background-color: #ED3246;
  border: 0;
  padding: 0.7vw;
  width: 11vw;
  color: #fff;
  cursor: pointer;
  outline: none;
  position: relative;
  display: flex;
  -webkit-transition: color 0.4s;
  transition: color 0.4s;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);

  .button-text{
    z-index: 2;
    margin: auto;
    font-size: 1.1vw;
    opacity: ${(props) => {
      if (props.textVisible) {
        return 1;
      }
      return 0;
    }};

    @media (max-width: 64em) {
      font-size: 4.1vw;
    }
  }

  &:after{
    background-color: #FFC400;
    content: '.';
    transform: skewX(15deg);
    position: absolute;
    top: 0;
    left: -10%;
    height: 100%;
    width: 0%;
    color: #FFC400;
    z-index: 1;
    -webkit-transition: width 0.4s;
    transition: width 0.4s;
  }

  &:hover{
    color: #262636;

    &:after{
      width: 120%;
    }
  }

  @media (max-width: 64em) {
    padding: 2.7vw;
    width: 28vw;
  }
`;

export const ButtonLoadingImage = styled.img`
  z-index: 22;
  position: absolute;
  width: 3vw;
  display: block;
  margin: auto;
  left: 33%;
  margin-top: -0.8vw;
  opacity: ${(props) => {
    if (props.visible) {
      return 1;
    }
    return 0;
  }};

  @media (max-width: 64em) {
    left: 32%;
    margin-top: -2.8vw;
    width: 10vw;
  }
`;

export const FlowerPotContainer = styled.div`
  position: relative;
  border-left: 1px solid;

  &:after{
    content: '.';
    background-color: #bab4c9;
    width: 50%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    z-index: -1;
    color: #bab4c9;
  }

  @media (max-width: 64em) {
    border: none;

    &:after{
      top: auto;
      right: auto;
      bottom: 0;
      width: 100%;
      height: 50%;
    }
  }
`;

export const ErrorMessage = styled.span`
  color: #ED3246;
  font-size: 1vw;
  margin-top: -0.7vw;
  display: block;
  margin-bottom: 1vw;

  @media (max-width: 64em) {
    font-size: 2.4vw;
    margin-top: -4.7vw;
    margin-bottom: 3vw;
  }
`;

export const HiddenSubmitButton = styled.div`
  display: none;
`;



// WEBPACK FOOTER //
// ./src/components/Contact/styles.js